var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 10,
    viewBox: "0 0 11 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 4V10H0V4H2ZM4 10C3.73478 10 3.48043 9.89464 3.29289 9.70711C3.10536 9.51957 3 9.26522 3 9V4C3 3.725 3.11 3.475 3.295 3.295L6.585 0L7.115 0.53C7.25 0.665 7.335 0.85 7.335 1.06L7.32 1.215L6.845 3.5H10C10.555 3.5 11 3.95 11 4.5V5.5C11 5.63 10.975 5.75 10.93 5.865L9.42 9.39C9.27 9.75 8.915 10 8.5 10H4ZM4 9H8.515L10 5.5V4.5H5.61L6.175 1.84L4 4.015V9Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg3);
export default __webpack_public_path__ + "static/media/3.0152f8ea.svg";
export { ForwardRef as ReactComponent };